import { CancelSelectedFile, DeleteStrikerIcon, EyeIcon } from "icons";
import styles from "./styles.module.scss";
import { DownloadIcon } from "icon-components/DownloadIcon";
import { FILE_EXTENSION_ICONS } from "pages/notes/constants";
import { UseLazyApiCallV2 } from "hooks";
import { Modal, Spin } from "antd";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { useCurrentUserContext } from "providers";
import { useState } from "react";

export const AttachedFiles = ({ files, message_id, loading }) => {
  const { user } = useCurrentUserContext();

  const { translator } = useLanguageTranslator();
  const uploadFilesTrans = translator("caseDetail.uploadFiles");
  const [preview, setPreview] = useState({
    open: false,
    url: null,
    contentType: null,
    fileName: null,
  });

  const [
    downloadAttachment,
    {
      data: downloadAttachmentData,
      isLoading: downloadAttachmentLoading,
      error: downloadAttachmentError,
    },
  ] = UseLazyApiCallV2({
    url: "/download_email_attachment",
    method: "POST",
  });
  const base64ToUrl = (base64, mimeType) => {
    const cleanBase64 = base64.includes(",") ? base64.split(",")[1] : base64;

    const byteCharacters = atob(cleanBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));

    const blob = new Blob([new Uint8Array(byteNumbers)], {
      type: mimeType || "application/octet-stream",
    });

    return URL.createObjectURL(blob);
  };
  const getFileName = (contentDisposition) => {
    if (!contentDisposition) return "download";

    const match = contentDisposition.match(/filename="?(.+?)"?$/);
    return match ? match[1] : "download";
  };

  async function handleClickDownload({
    attachment_id,
    email,
    message_id,
    key,
  }) {
    try {
      const res = await downloadAttachment({
        params: { attachment_id, email, message_id },
      });

      const contentType = res?.headers?.["Content-Type"];
      const disposition = res?.headers?.["Content-Disposition"];
      const fileName = getFileName(disposition);

      const fileUrl = base64ToUrl(res?.body, contentType);

      const isPreviewable =
        contentType?.startsWith("image/") || contentType === "application/pdf";

      if (key === "open" && isPreviewable) {
        setPreview({
          open: true,
          url: fileUrl,
          contentType,
          fileName,
        });
        return;
      }

      if (key === "download") {
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileName;
        a.click();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  return (
    <div className={styles.uploadedFiles}>
      <Spin spinning={downloadAttachmentLoading || loading}>
        <div className={styles.header}>
          <div className={styles.heading}>{uploadFilesTrans.uploadedFiles}</div>
          <div className={styles.totalFiles}>
            {uploadFilesTrans.totalFiles}: <span>{files?.length}</span>
          </div>
        </div>
        <div className={styles.files}>
          {files?.map((item) => {
            const fileExtension = item?.name?.split(".")[1];
            const FileExtensionIcon = FILE_EXTENSION_ICONS[fileExtension];
            return (
              <div className={styles.singleFile} key={item?.attachmentId}>
                <div className={styles.iconAndName}>
                  <FileExtensionIcon />
                  <div>{item?.name}</div>
                </div>
                <div className={styles.actionIcons}>
                  <div
                    className={styles.downloadIcon}
                    onClick={() =>
                      handleClickDownload({
                        attachment_id: item?.attachmentId,
                        message_id,
                        email: user?.email,
                        key: "download",
                      })
                    }
                  >
                    <DownloadIcon fill="#CD2A3F" />
                  </div>

                  <div
                    className={styles.deleteIcon}
                    onClick={() =>
                      handleClickDownload({
                        attachment_id: item?.attachmentId,
                        message_id,
                        email: user?.email,
                        key: "open",
                      })
                    }
                  >
                    <EyeIcon
                      style={{ cursor: "pointer", userSelect: "none" }}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Spin>
      <Modal
        centered
        open={preview.open}
        onCancel={() => setPreview({ open: false })}
        footer={null}
        width="100dvw"
        styles={{
          content: {
            minHeight: "97dvh",
          },
        }}
        destroyOnClose
      >
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          {preview.contentType === "application/pdf" && (
            <iframe
              src={preview.url}
              style={{ width: "100%", height: "93dvh", border: "none" }}
              title="PDF Preview"
            />
          )}

          {preview.contentType?.startsWith("image/") && (
            <img
              src={preview.url}
              alt={preview.fileName}
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                display: "block",
                margin: "0 auto",
              }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};
